import { render, staticRenderFns } from "./DoremiEditorView.vue?vue&type=template&id=0d8e5968&scoped=true"
import script from "./DoremiEditorView.vue?vue&type=script&lang=ts"
export * from "./DoremiEditorView.vue?vue&type=script&lang=ts"
import style0 from "./DoremiEditorView.vue?vue&type=style&index=0&id=0d8e5968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8e5968",
  null
  
)

export default component.exports